import { sendGet, sendPost } from "./axios";

export const getListTherapistNominations = (params) => sendGet(`/therapist-nominations`, params);

export const getListTherapistNominationsByTherapist = (therapistId, params = {}) => sendGet(`/therapist-nominations/${therapistId}`, params);

export const updateTherapistManagement = (therapistId, params) => sendPost(`/therapist-nominations/${therapistId}`, params);
